import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router);
import {
  homeChildren
} from './homeChildren'
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: resolve => require(['@/components/common/Home'], resolve),
      meta: {
        requiresAuth: false
      },
      children: homeChildren
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js